import { Button, Stack } from "@mui/material";
import { Box } from "@mui/system";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import ReactSignatureCanvas from "react-signature-canvas";
import SignatureCanvas from 'react-signature-canvas'

type SignatureProps = {
    onEnd: (signatureDataUrl: string) => void
    readOnly?: boolean
    src: string
}

function Signature(props: SignatureProps) {
    const { onEnd, readOnly, src } = props;
    const sigCanvasRef = useRef<SignatureCanvas | null>(null)
    const {t} = useTranslation()
    const handleClearSignatureCanvas = () => {
        sigCanvasRef.current?.clear()
      }
    
    return (
        <Stack  alignItems="center" justifyContent="center" spacing={1}>
           {readOnly && <>
            <ReactSignatureCanvas
                        ref={sigCanvasRef}
                        backgroundColor="#FFF"
                        canvasProps={{
                            style: {
                                border: '2px dashed rgba(0, 0, 0, 0.08)',
                                flex: 1,
                                width: '100%',
                                height: 'auto',
                                minHeight: '100px'
                            }
                        }}
                        onEnd={() => {
                            onEnd(sigCanvasRef.current?.getTrimmedCanvas().toDataURL('image/png') || '')
                        }}
                    />
            <Box sx={{ alignSelf: 'flex-start' }}>
                <Button color="warning" onClick={handleClearSignatureCanvas} variant="outlined" >{t('common:button.clear.label')}</Button>
            </Box> </>}
            {!readOnly && <Box  component="img" alt="signature" src={src} maxWidth={'100%'}/>}
        </Stack>
    );
}

export default Signature;